import { normalizeSocialProfiles } from "@/lib/publications/socialProfiles";

export default function SocialProfileLinks({ profiles, className = "flex flex-wrap gap-3", linkClassName = "inline-flex min-w-8 h-8 items-center justify-center rounded-full bg-black px-2 text-xs font-bold text-white hover:opacity-80" }) {
  const configured = normalizeSocialProfiles(profiles);
  if (!configured.length) return null;
  return (
    <div className={className}>
      {configured.map(profile => (
        <a key={profile.id} href={profile.url} aria-label={profile.platform} title={profile.platform} target="_blank" rel="noopener noreferrer" className={linkClassName}>
          {profile.iconKey ? profile.iconKey.slice(0, 2).toUpperCase() : profile.platform.slice(0, 2).toUpperCase()}
        </a>
      ))}
    </div>
  );
}
